import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";

import { useUIFilesStore } from "@/stores/ui-files.store";

import { ContentStructureSection } from "@/models/content-structure.model";
import { ProductItem } from "@/models/product.model";

import Popup from "@/components/Popup.vue";
import FileLibraryForm from "@/components/popups/attachments/attach-file/FileLibraryForm.vue";
import OnlineForm from "@/components/popups/attachments/attach-file/OnlineForm.vue";
import UploadForm from "@/components/popups/attachments/attach-file/UploadForm.vue";

const UPLOAD_FILE = 0;

export default /*#__PURE__*/_defineComponent({
  __name: 'AttachFile',
  setup(__props) {

const uiFilesStore = useUIFilesStore();

const activeTab = ref<number>(UPLOAD_FILE);

const target = computed<ContentStructureSection | ProductItem | null>(() => {
  if (uiFilesStore.sectionToAttachFile) {
    return uiFilesStore.sectionToAttachFile;
  }
  if (uiFilesStore.productToAttachFile) {
    return uiFilesStore.productToAttachFile;
  }
  return null;
});
const name = computed<string>(() => {
  return target.value ? target.value.name : "";
});

return (_ctx: any,_cache: any) => {
  const _component_b_tab_item = _resolveComponent("b-tab-item")!
  const _component_b_tabs = _resolveComponent("b-tabs")!

  return (_openBlock(), _createBlock(Popup, {
    "data-testing-modal-card": 'attach-file-card',
    onClosePopup: _unref(uiFilesStore).closeAttachFileModal
  }, {
    header: _withCtx(() => [
      _createElementVNode("h3", null, [
        _cache[1] || (_cache[1] = _createElementVNode("span", null, "Attach content to ", -1)),
        _createElementVNode("i", null, _toDisplayString(name.value), 1)
      ])
    ]),
    body: _withCtx(() => [
      _createVNode(_component_b_tabs, {
        "data-testing": "tabs",
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
        "destroy-on-hide": true,
        animated: false,
        position: 'is-centered',
        expanded: true,
        class: "attach-file-tabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_tab_item, { label: "Upload" }, {
            default: _withCtx(() => [
              _createVNode(UploadForm)
            ]),
            _: 1
          }),
          _createVNode(_component_b_tab_item, { label: "Link to online content" }, {
            default: _withCtx(() => [
              _createVNode(OnlineForm)
            ]),
            _: 1
          }),
          _createVNode(_component_b_tab_item, { label: "Select from Library" }, {
            default: _withCtx(() => [
              _createVNode(FileLibraryForm)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["onClosePopup"]))
}
}

})